//公共
import base from './map/base.js';

//语文公共
import chineseCommon from './map/chinese/chinese_common.js'
//小学语文
import selectTask from './map/chinese/selectTask.js'
import inspectCH from './map/chinese/inspect.js'

//数学公共
import mathCommon from './map/math/math_common.js'
//小学数学
import arrangeMath from './map/math/math/arrange.js'
import inspectMath from './map/math/math/inspect.js'

//英语公共
import englishCommon from './map/english/english_common.js'
//小学英语
import arrangeEN from './map/english/english/arrange.js'
import inspectEN from './map/english/english/inspect.js'

//素质驿站-爱尚书法
import QSteaRe from "./map/qualityStation/tea/release/index.js"
import QSteaCh from "./map/qualityStation/tea/check/index.js"

//家校沟通
import communication from "./map/communication/index.js"


//素质驿站爱尚书法宣传页 
import calligraphy from './map/activity/calligraphy/index'

// 河南科技报
import xcpTea from './map/activity/xcpTea/index.js';

//2022暑假活动添加 青柠阅读也在期末活动之内
// import qnyd from './map/activity/qnyd/index.js'


//个性化学习
import personaLearning from './map/personaLearning/index.js'

//2023上书法风采
// import sffc2023 from './map/activity/2023sffc/index.js';


//班级管理
import teaclass from './map/class/index.js';
//用户中心
import mine from './map/mine/index.js';


//2023下书法活动
import shujia2023 from './map/activity/2023shujia/index.js';

//2023下书法活动
import sfhd2023 from './map/activity/2023sfhd/index.js';

//2023下期中检测
import qz2023 from './map/activity/2023qz/index.js';

//2023下期末检测
import qm2023 from './map/activity/2023qm/index.js';
//围棋作业
import weiqi from './map/weiqi/index.js';

//围棋作业
import sf_clock from './map/activity/sf_clock/index.js';

//2023寒假活动
import winter2023 from './map/activity/2023winter/index.js';

//2024领跑新学期活动
import newterm2024 from './map/activity/2024newterm/index.js';

//2024happy
import happy2024 from './map/activity/2024happy/index.js';

//2024上期中检测
import qzjc2024 from './map/activity/2024qzjc/index.js';

//2024上期末检测
import qmjc2023 from './map/activity/2023qmjc/index.js';


//2024小升初
import xsc from './map/activity/xsc/index.js';

//2024下期中检测
import qz2024 from './map/activity/2024qz/index.js';

//2024下期末检测
import qm2024 from './map/activity/2024qm/index.js';

//2024寒假活动
import winter2024 from './map/activity/2024winter/index.js';

let routes = [];
let myRoutes = routes.concat(
    base,
    chineseCommon,
    selectTask,
    inspectCH,
    mathCommon,
    arrangeMath,
    inspectMath,
    englishCommon,
    arrangeEN,
    inspectEN,
    QSteaRe,
    QSteaCh,
    communication,
    calligraphy,
    xcpTea,
    personaLearning,
    teaclass,
    mine,
    sfhd2023,
    weiqi,
    qm2023,
    qz2023,
    sf_clock,
    winter2023,
    newterm2024,
    happy2024,
    qzjc2024,
    qmjc2023,
    shujia2023,
    xsc,
    qz2024,
    qm2024,
    winter2024
);
export default myRoutes;
